import { AxiosRequestConfig } from 'axios'
import { useApi } from '../hooks'
import { ConfluencePage } from '../types'

const api = useApi('v2')

export async function getConfluencePage(
  id: string,
  config: AxiosRequestConfig
): Promise<ConfluencePage> {
  const response = await api.get(`/confluence/pages/${id}`, config)

  return response.data
}
